// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BKC2","field":"styles_field__29VVi","fieldCol":"styles_fieldCol__1txr-","diffCol":"styles_diffCol__3NDte","diff":"styles_diff__sMiff"};